export var getMarketId = function (market) {
    if (!market || !market.id) {
        return "";
    }
    var a = market.id.match("^[1-3]_");
    if (a) {
        return market.id.slice(2, market.id.length);
    }
    return market.id;
};
//# sourceMappingURL=getMarketId.js.map